import { Leaf, MapPin, Wrench, Sun, Banknote } from "lucide-react";

const ITEMS = [
  { icon: MapPin, label: "NZ-focused install support" },
  { icon: Wrench, label: "270L · 320L series" },
  { icon: Leaf, label: "Gas & electric replacements" },
  { icon: Sun, label: "Solar & battery ready" },
  { icon: Banknote, label: "Quote & finance support" },
];

export default function TrustStrip() {
  return (
    <section data-testid="trust-strip" className="border-y border-[#E2E8F0] bg-[#F8FAFC]">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 py-8">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-6 items-center">
          {ITEMS.map((it, i) => (
            <div key={i} className="flex items-center gap-3 text-sm text-[#0B132B]">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-white border border-[#E2E8F0] shadow-sm">
                <it.icon className="h-4 w-4 text-[#10B981]" strokeWidth={1.8} />
              </span>
              <span className="font-medium leading-tight">{it.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
